/**
 * Storage Actions - File upload endpoints
 *
 * Module-scope actions:
 * - upload: General file upload
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'

export { uploadAction } from './upload.action.js'

import { uploadAction } from './upload.action.js'

/** All storage actions typed for module actions array */
export const storageActions: ActionDefinition[] = [
  uploadAction
]
